import { Component, ChangeDetectionStrategy, HostListener, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Testimonial {
  quote: string;
  author: string;
  role: string;
  company: string;
  stars: number;
  avatarUrl: string;
}

@Component({
  selector: 'app-recruiter-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-testimonials.component.html',
  styleUrls: ['./recruiter-testimonials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterTestimonialsComponent implements OnInit, OnDestroy {
  currentIndex = 0;
  itemsToShow = 3;
  private autoPlayTimer: any;

  @HostListener('window:resize')
  onResize() {
    this.updateItemsToShow();
  }

  constructor(private cdr: ChangeDetectorRef) {
    this.updateItemsToShow();
  }

  ngOnInit() {
    this.startAutoPlay();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  updateItemsToShow() {
    if (typeof window !== 'undefined') {
      this.itemsToShow = window.innerWidth >= 768 ? 3 : 1;
      // Ensure we don't slide past the end when resizing
      this.currentIndex = Math.min(this.currentIndex, Math.max(0, this.testimonials.length - this.itemsToShow));
    }
  }

  readonly testimonials: Testimonial[] = [
    {
      quote: "BeExpert cut our screening time by 60%. The AI ranking consistently surfaces genuinely strong candidates we would have missed.",
      author: "Meera Krishnan",
      role: "Talent Acquisition Lead",
      company: "TCS",
      stars: 5,
      avatarUrl: "https://i.pravatar.cc/150?img=47"
    },
    {
      quote: "Campus hiring at scale finally feels effortless. Proctored assessments and AI interviews let us evaluate thousands fairly.",
      author: "Arjun Mehta",
      role: "Head of Recruiting",
      company: "Infosys",
      stars: 5,
      avatarUrl: "https://i.pravatar.cc/150?img=11"
    },
    {
      quote: "One platform for jobs, assessments, interviews and analytics. Our time-to-hire dropped by 40% in the first quarter.",
      author: "Sarah Johnson",
      role: "Senior Technical Recruiter",
      company: "Microsoft",
      stars: 5,
      avatarUrl: "https://i.pravatar.cc/150?img=5"
    },
    {
      quote: "The seamless integration with our ATS and the incredible accuracy of the coding assessments have transformed our engineering hiring.",
      author: "David Chen",
      role: "VP of Engineering",
      company: "Amazon",
      stars: 5,
      avatarUrl: "https://i.pravatar.cc/150?img=12"
    },
    {
      quote: "We've scaled our remote hiring globally without compromising on quality, all thanks to the intelligent proctoring system.",
      author: "Elena Rodriguez",
      role: "Global Talent Director",
      company: "Google",
      stars: 5,
      avatarUrl: "https://i.pravatar.cc/150?img=32"
    }
  ];

  next() {
    if (this.currentIndex < this.testimonials.length - this.itemsToShow) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Wrap around for auto-play
    }
    this.cdr.markForCheck();
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.cdr.markForCheck();
    }
  }

  startAutoPlay(): void {
    if (typeof window !== 'undefined') {
      this.autoPlayTimer = setInterval(() => {
        this.next();
      }, 4000);
    }
  }

  stopAutoPlay(): void {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
    }
  }
}
